// nullifyEmptyStrings returns a copy of the data object with empty string fields set to null
export function nullifyEmptyStrings<T>(data: T): T {
  const res = { ...data }
  Object.keys(res).forEach((key) => {
    if (res[key] === '') res[key] = null
  })
  return res
}

// removeEmptyFields returns a copy of the data object with empty string fields deleted
// unless the field is present in the optional current object
export function removeEmptyFields<T>(data: T, current?: T): T {
  const res = { ...data }
  Object.keys(data).forEach((key) => {
    if (res[key] === '' || res[key] == null) {
      if (current && current[key]) {
        res[key] = null
      } else {
        delete res[key]
      }
    }
  })
  return res
}
